import { Box, MenuItem, Popover } from '@mui/material';
import { Button, Typography, colors } from '@sweep-io/sweep-design';
import usePopover from '../../../hooks/usePopover';
import { AssignmentFieldOption } from './assignmentFieldOptions';

interface AssignmentFieldMenuProps {
  options: AssignmentFieldOption[];
  onSelect: (option: AssignmentFieldOption) => void;
  disabled?: boolean;
  buttonVariant?: 'flat-blue' | 'flat-grey';
}

/**
 * A button that opens a popover menu for selecting assignment fields.
 * Used in both Recipients and Message sections.
 */
export const AssignmentFieldMenu = ({
  options,
  onSelect,
  disabled,
  buttonVariant = 'flat-blue',
}: AssignmentFieldMenuProps) => {
  const { isPopoverOpen, closePopover, openPopover, anchorElement, anchorRef } = usePopover();

  const handleSelect = (option: AssignmentFieldOption) => {
    onSelect(option);
    closePopover();
  };

  return (
    <Box>
      <Button
        variant={buttonVariant}
        size="small"
        startIconName="Plus"
        ref={anchorRef}
        onClick={openPopover}
        disabled={disabled}
      >
        From Assignment
      </Button>

      <Popover
        open={isPopoverOpen}
        onClose={closePopover}
        anchorEl={anchorElement}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      >
        <Box sx={{ p: 1, minWidth: '200px' }}>
          {options.map((option) => (
            <MenuItem
              key={option.value}
              onClick={() => handleSelect(option)}
              sx={{
                padding: '8px 12px',
                borderRadius: '4px',
                '&:hover': {
                  backgroundColor: colors.grey[100],
                },
              }}
            >
              <Typography variant="body">{option.label}</Typography>
            </MenuItem>
          ))}
        </Box>
      </Popover>
    </Box>
  );
};
